import React, { useRef, useState } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import { toast } from 'react-toastify'

export default function FileSelector({ show, onHide, addFiles }) {
  const inputFileRef = useRef()
  const inputFolderRef = useRef()
  const [isDragActive, setIsDragActive] = useState(false)

  const MAX_FILES = 100
  const MAX_FILE_SIZE = 10 * 1024 * 1024 * 1024 // 10GB

  const handleDrop = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setIsDragActive(false)

    const filesArr = Array.from(e.dataTransfer.files || [])
    if (!filesArr.length) return

    addFiles(filesArr) // ✅ corrigido: passa arquivos diretamente
    onHide()
  }

  const handleDragOver = e => {
    e.preventDefault()
    e.stopPropagation()
    setIsDragActive(true)
  }

  const handleDragLeave = e => {
    e.preventDefault()
    e.stopPropagation()
    setIsDragActive(false)
  }

  const handleFiles = (files, isFolder = false) => {
    const filesArr = Array.from(files)
console.log('[FileSelector] handleFiles', filesArr);
    if (filesArr.length > MAX_FILES) {
      toast.error(`Máximo de ${MAX_FILES} arquivos por envio!`)
      return
    }

    const tooBig = filesArr.find(f => f.size > MAX_FILE_SIZE)
    if (tooBig) {
      toast.error(`Arquivo "${tooBig.name}" excede o limite de 10 GB`)
      return
    }

    addFiles(filesArr) // ✅ corrigido: não encapsula
    toast.success(`${filesArr.length} arquivo${filesArr.length > 1 ? 's' : ''} adicionad${filesArr.length > 1 ? 'os' : 'o'} à fila`)
    onHide()
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Selecionar arquivos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          className={`vd-dropzone ${isDragActive ? 'drag-active' : ''}`}
          style={{
            border: '2px dashed #813FBF',
            borderRadius: 12,
            padding: 32,
            textAlign: 'center',
            background: isDragActive ? '#f7f2fa' : '#fff',
            marginBottom: 16,
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
        >
          <div style={{ fontSize: 16, color: '#813FBF', marginBottom: 8 }}>
            Arraste arquivos aqui
          </div>
          <div className="text-muted" style={{ fontSize: 13 }}>
            ...ou clique no botão abaixo
          </div>
        </div>

        <div className="text-center">
          <Button onClick={() => inputFileRef.current.click()}>
            Escolher arquivos
          </Button>
          <input
            ref={inputFileRef}
            type="file"
            multiple
            style={{ display: 'none' }}
            onChange={e => handleFiles(e.target.files, false)}
          />
          <Button className="ms-2" variant="secondary" onClick={() => inputFolderRef.current.click()}>
            Escolher pasta
          </Button>
          <input
            ref={inputFolderRef}
            type="file"
            multiple
            webkitdirectory=""
            directory=""
            style={{ display: 'none' }}
            onChange={e => handleFiles(e.target.files, true)}
          />
        </div>
      </Modal.Body>
    </Modal>
  )
}
